import { getDefaultExportFromCjs } from " commonjsHelpers.js";
import { __require as requireRollupEntry } from "/home/runner/_work/ccmo-apimgt-devportlonbrd-ng-ui/ccmo-apimgt-devportlonbrd-ng-ui/dist/widget/browser/rollup-entry.js";
var rollupEntryExports = requireRollupEntry();
export { rollupEntryExports as __moduleExports };
export default /*@__PURE__*/getDefaultExportFromCjs(rollupEntryExports);